import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61b1ef90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-[2px] border-l border-gray-300" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hidden md:inline-block whitespace-nowrap" }, "v2.0-alpha", -1))
const _hoisted_3 = { class: "rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden" }
const _hoisted_4 = { class: "relative grid gap-6 bg-white px-2 py-3 sm:gap-8 sm:p-2" }
const _hoisted_5 = { class: "column text-right" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/ulixee",
    class: "no-underline"
  }, "Github Repositories")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_PopoverButton = _resolveComponent("PopoverButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PopoverPanel = _resolveComponent("PopoverPanel")!
  const _component_Popover = _resolveComponent("Popover")!

  return (_openBlock(), _createBlock(_component_Popover, { class: "relative" }, {
    default: _withCtx(({ open }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_PopoverButton, {
          class: _normalizeClass([open ? 'text-gray-900' : 'text-purple-900', 'h-[34px] px-3 relative -mr-3 font-light group inline-flex items-center rounded hover:bg-ulixee-verylight'])
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createTextVNode(),
            _createVNode(_component_ChevronDownIcon, {
              class: _normalizeClass([open ? 'text-gray-600' : 'text-purple-900', 'h-4 w-4 stroke-1 group-hover:text-gray-500']),
              "aria-hidden": "true"
            }, null, 8, ["class"])
          ]),
          _: 2
        }, 1032, ["class"])
      ]),
      _createTextVNode(),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-200",
        "enter-from-class": "opacity-0 translate-y-1",
        "enter-to-class": "opacity-100 translate-y-0",
        "leave-active-class": "transition ease-in duration-150",
        "leave-from-class": "opacity-100 translate-y-0",
        "leave-to-class": "opacity-0 translate-y-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_PopoverPanel, { class: "absolute z-10 right-0 transform mt-3 px-2 w-screen max-w-xs sm:px-0" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("ul", null, [
                        _hoisted_6,
                        _createTextVNode(),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            to: "/how-to-contribute",
                            class: "no-underline"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("How To Contribute")
                            ]),
                            _: 1
                          })
                        ]),
                        _createTextVNode(),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            to: "/code-of-conduct",
                            class: "no-underline"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Code of Conduct")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}